import { render, staticRenderFns } from "./GcDropzone.vue?vue&type=template&id=660a73d0"
import script from "./GcDropzone.vue?vue&type=script&lang=ts"
export * from "./GcDropzone.vue?vue&type=script&lang=ts"
import style0 from "./GcDropzone.vue?vue&type=style&index=0&id=660a73d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports